import { getPropertyById } from "../../../../SOA/api";
import { getSuiteInspectionById } from "./Api";

export const defaultSuiteInspection = {
  type: '',
  unit_number: '',
  cleanliness: '',
  any_damages: false,
  number_of_dogs: 0,
  number_of_cats: 0,
  plumbing: '',
  dye_test: '',
  lubricate_dead_bolt: '',
  number_of_people: '',
  signs_of_smoking: false,
  comments: '',
  overall_status: '',
  closed_window: '',
  furniture_away: '',
  hrv_setting: '',
  furnace_filter: '',
  flooring_damage: '',
  filters_replaced: '',
  hrv_photos: [],
  attachments: [],
  property_details: {
    property_id: '',
    building_name: '',
  },
  inspection_date: new Date().toISOString().split('T')[0],
};

export const transformInspectionForForm = (inspection = {}) => {
  if (!inspection || typeof inspection !== 'object') {
    return { ...defaultSuiteInspection };
  }
  return {
    // _id and is_draft let the form update this record and tell a draft from a completed one.
    ...(inspection._id ? { _id: inspection._id } : {}),
    is_draft: inspection.is_draft === true,
    type: inspection.type || '',
    unit_number: inspection.unit_number || '',
    cleanliness: inspection.cleanliness || '',
    any_damages: inspection.any_damages ?? false,
    number_of_dogs: inspection.number_of_dogs ?? 0,
    number_of_cats: inspection.number_of_cats ?? 0,
    plumbing: inspection.plumbing || '',
    dye_test: inspection.dye_test || '',
    lubricate_dead_bolt: inspection.lubricate_dead_bolt || '',
    number_of_people: inspection.number_of_people != null ? String(inspection.number_of_people) : '',
    signs_of_smoking: inspection.signs_of_smoking ?? false,
    comments: inspection.comments || '',
    overall_status: inspection.overall_status || '',
    closed_window: inspection.closed_window || '',
    furniture_away: inspection.furniture_away || '',
    hrv_setting: inspection.hrv_setting || '',
    furnace_filter: inspection.furnace_filter || '',
    flooring_damage: inspection.flooring_damage || '',
    filters_replaced: inspection.filters_replaced || '',
    hrv_photos: inspection.hrv_photos || [],
    attachments: inspection.attachments || [],
    inspection_date: inspection.inspection_date
      ? new Date(inspection.inspection_date).toISOString().split('T')[0]
      : new Date().toISOString().split('T')[0],
    property_details: {
      property_id:
        inspection.property_details?.property_id?._id ||
        inspection.property_details?.property_id ||
        inspection.property_id ||
        '',
      building_name: inspection.property_details?.building_name || '',
    },
  };
};

export const getPropertyDetailsForSuiteInspection = async (propertyId) => {
  try {
    if (!propertyId) {
      throw new Error('Property ID is required');
    }
    const property = await getPropertyById(propertyId);
    if (!property) {
      throw new Error('Property not found');
    }
    return { property };
  } catch (error) {
    console.error('Error fetching property details for suite inspection:', error);
    throw error;
  }
};

export const autoFillPropertyDetails = async (
  currentFormValues,
  propertyId,
  buildingName = ''
) => {
  try {
    if (!propertyId) {
      return {
        ...currentFormValues,
        property_details: {
          property_id: '',
          building_name: '',
        },
        attachments: currentFormValues.attachments || [],
      };
    }

    const { property } = await getPropertyDetailsForSuiteInspection(propertyId);

    let buildingNameToUse = buildingName;
    if (!buildingNameToUse && property.building && Array.isArray(property.building)) {
      buildingNameToUse = property.building[0]?.buildingName || '';
    }

    return {
      ...currentFormValues,
      property_details: {
        property_id: propertyId,
        building_name: buildingNameToUse.trim(),
      },
      inspection_date: currentFormValues.inspection_date || new Date().toISOString().split('T')[0],
      type: currentFormValues.type || '',
      unit_number: currentFormValues.unit_number || '',
      cleanliness: currentFormValues.cleanliness || '',
      any_damages: currentFormValues.any_damages ?? false,
      number_of_dogs: currentFormValues.number_of_dogs ?? 0,
      number_of_cats: currentFormValues.number_of_cats ?? 0,
      plumbing: currentFormValues.plumbing || '',
      dye_test: currentFormValues.dye_test || '',
      lubricate_dead_bolt: currentFormValues.lubricate_dead_bolt || '',
      number_of_people: currentFormValues.number_of_people || '',
      signs_of_smoking: currentFormValues.signs_of_smoking ?? false,
      comments: currentFormValues.comments || '',
      overall_status: currentFormValues.overall_status || '',
      attachments: currentFormValues.attachments || [],
      closed_window: '',
      furniture_away: '',
      hrv_setting: '',
      furnace_filter: '',
      flooring_damage: '',
    };
  } catch (error) {
    console.error('Failed to auto-fill property details:', error);
    return currentFormValues;
  }
};

export const getSuiteInspectionInitialValues = async (id) => {
  if (!id) return { ...defaultSuiteInspection };

  try {
    const inspection = await getSuiteInspectionById(id);
    return transformInspectionForForm(inspection);
  } catch (error) {
    console.error('Failed to fetch suite inspection for editing:', error);
    return { ...defaultSuiteInspection };
  }
};